module.exports = __webpack_public_path__ + "app/img/logo2.3501d96f.png";